module.exports = __webpack_public_path__ + "img/info-filled-icon.4b5ab0e.svg";